import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";
import {
  formatDateForDisplay,
  formatDateForPopUp,
} from "../../../../utils/Common";

const AchievementPopUp = ({
  achievement,
  isEditMode,
  closeModal,
  handleAddAchievement,
  handleUpdateAchievement,
}) => {
  const [formData, setFormData] = useState({
    title: achievement?.title || "",
    issuing_organization: achievement?.issuing_organization || "",
    date_received: formatDateForPopUp(achievement?.date_received) || "",
    nature: achievement?.nature_name || "",
    description: achievement?.description || "",
    country_location: achievement?.country_location || "",
  });

  const achievementTypes = [
    "Academic",
    "Professional",
    "Research",
    "Publication",
    "Award",
    "Certification",
    "Other",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.title ||
      !formData.issuing_organization ||
      !formData.date_received ||
      !formData.nature
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    const today = new Date();
    const selectedDate = new Date(formData.date_received);
    if (selectedDate > today) {
      toast.error("Date cannot be in the future");
      return;
    }

    if (isEditMode) {
      handleUpdateAchievement(formData);
    } else {
      handleAddAchievement(formData);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] max-h-[90vh] bg-gray-900 rounded-[20px] overflow-hidden flex flex-col"
      >
        <div className="overflow-y-auto flex-1 p-6">
          <form
            onSubmit={handleSubmit}
            className="text-white flex flex-col space-y-6"
          >
            <h2 className="text-xl font-bold mb-4">
              {isEditMode ? "Edit Achievement" : "Add Achievement"}
            </h2>

            {/* Title */}
            <div className="relative z-0 w-full group">
              <label htmlFor="title" className="block text-sm">
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="title"
                id="title"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.title}
                required
              />
            </div>

            {/* Issuing Organization */}
            <div className="relative z-0 w-full group">
              <label htmlFor="issuing_organization" className="block text-sm">
                Issuing Organization <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="issuing_organization"
                id="issuing_organization"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.issuing_organization}
                required
              />
            </div>

            {/* Date Received */}
            <div className="relative z-0 w-full group">
              <label htmlFor="date_received" className="block text-sm">
                Date Received <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="date_received"
                id="date_received"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.date_received}
                required
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            {/* Nature */}
            <div className="relative z-0 w-full group">
              <label htmlFor="nature" className="block text-sm">
                Type <span className="text-red-500">*</span>
              </label>
              <select
                name="nature"
                id="nature"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.nature}
                required
              >
                <option value="">Select Type</option>
                {achievementTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            {/* Country Location */}
            <div className="relative z-0 w-full group">
              <label htmlFor="country_location" className="block text-sm">
                Country
              </label>
              <input
                type="text"
                name="country_location"
                id="country_location"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.country_location}
              />
            </div>

            {/* Description */}
            <div className="relative z-0 w-full group">
              <label htmlFor="description" className="block text-sm">
                Description
              </label>
              <textarea
                name="description"
                id="description"
                rows="4"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.description}
              />
            </div>

            <p className="text-sm text-gray-400">
              <span className="text-red-500">*</span> compulsory fields
            </p>

            <div className="flex items-center justify-between mt-5 space-x-4">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                {isEditMode ? "Update" : "Save"}
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default AchievementPopUp;
